import { render, staticRenderFns } from "./DashboardChart.vue?vue&type=template&id=364ad57a"
import script from "./DashboardChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardChart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DashboardChart.vue?vue&type=style&index=0&id=364ad57a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports